import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_INSTAGRAM_AUTH } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    var restUrl =
      window.location.href.split('?').length > 1
        ? window.location.href.split('?')[1]
        : window.location.href.split('?')[0];
    var state = restUrl.split('=').length > 1 ? restUrl.split('=')[1] : '';
    if (this.props.instagramId) {
      AxiosAPI({
        method: 'post',
        url: `${API_INSTAGRAM_AUTH}/code/${
          this.props.instagramId
        }?group_id=${getGroupID()}&property_id=${
          this.props.propertyId
        }&code=${state}`,
        data: { code: state, redirectUrl: `https://${localStorage.getItem('host_name_url')}/${process.env.REACT_APP_INSTA_REDIRECT_URL}` },
      }).then((res) => {
        localStorage.setItem('ShowInstagramMessage', true);
        window.location.href = `/app/pages/integration/channels`;
      });
    } else {
      window.location.href = `/app/pages/integration/channels`;
    }
  }

  render() {
    return <Fragment></Fragment>;
  }
}
const mapStateToProps = ({ settings, service }) => {
  const { propertyId, instagramId } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    instagramId,
    featuresUrl
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
